/**
 * The VisiList logo, cropped from the artwork at the repo root to drop the
 * wordmark — unreadable at rail size, and the taskbar already labels the app.
 *
 * Served from public/, so it's referenced by URL rather than imported.
 *
 * It keeps its own colours rather than inheriting currentColor, so unlike
 * every other rail icon it does not invert when selected. See Rail.css.
 */
export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <img src="/brand/visilist-mark.png" width={size} height={size} alt="" className="brand-mark" />
  );
}
